// 星球管理
import {post, downFile, postfile} from './http'
const baseUrl = '/api/admin/star'

// 移除成员列表
export const deleteMeber = v => post(`${baseUrl}/deleteMeber`, v.data, v.success, v.error)

// 星球列表分页查询
export const findStarByCustomerId = v => post(`${baseUrl}/findStarByCustomerId`, v.data, v.success, v.error)

// 成员列表
export const findStarMember = v => post(`${baseUrl}/findStarMember`, v.data, v.success, v.error)

// 星球资料列表分页查询
export const findStarfile = v => post(`${baseUrl}/findStarfile`, v.data, v.success, v.error)

// 星球资料详情
export const findStarfileInfo = v => post(`${baseUrl}/findStarfileInfo`, v.data, v.success, v.error)

// 星球笔记列表分页查询
export const findStarnotes = v => post(`${baseUrl}/findStarnotes`, v.data, v.success, v.error)

// 获取星球内容列表（笔记/资料/主题）详情
export const getContentMap = v => post(`${baseUrl}/getContentMap`, v.data, v.success, v.error)

// 星球主题列表分页查询
export const getStarSubject = v => post(`${baseUrl}/getStarSubject`, v.data, v.success, v.error)

// 编辑星球
export const updateStarByInnerid = v => post(`${baseUrl}/updateStarByInnerid`, v.data, v.success, v.error)

// 新增星球
export const saveStarInfo = v => post(`${baseUrl}/saveStarInfo`, v.data, v.success, v.error)

// 隐藏或解散星球
export const updateStarByStatus = v => post(`${baseUrl}/updateStarByStatus`, v.data, v.success, v.error)

// 隐藏动态或恢复动态或删除
export const updateStarSubjectByStatus = v => post(`${baseUrl}/updateStarSubjectByStatus`, v.data, v.success, v.error)

// 隐藏资料或恢复资料或删除
export const updateStarfileByStatus = v => post(`${baseUrl}/updateStarfileByStatus`, v.data, v.success, v.error)

// 隐藏笔记或显示笔记或删除
export const updateStarnotesByStatus = v => post(`${baseUrl}/updateStarnotesByStatus`, v.data, v.success, v.error)

// 解除管理员或设为管理员
export const uploadMeberRole = v => post(`${baseUrl}/uploadMeberRole`, v.data, v.success, v.error)

// 星球详情
export const getStarInfo = v => post(`${baseUrl}/getStarInfo`, v.data, v.success, v.error)

// 列表内容详情
export const getStarContentDetail = v => post(`${baseUrl}/getStarContentDetail`, v.data, v.success, v.error)

// 星球列表
export const findStarList = v => post(`${baseUrl}/findStarList`, v.data, v.success, v.error)

// 敏感词列表
export const getWordsList = v => post(`${baseUrl}/getCwKmcHostforbidwordsList`, v.data, v.success, v.error)

// 新建or编辑敏感词
export const saveWords = v => post(`${baseUrl}/saveCwKmcHostforbidwords`, v.data, v.success, v.error)

// 删除敏感词
export const delWords = v => post(`${baseUrl}/deleteCwKmcHostforbidwords`, v.data, v.success, v.error)

// 下载敏感词模板
export const downloadWords = v => downFile(`${baseUrl}/downloadCwKmcHostforbidwordsExcel`, v.data, v.success, v.error)

// 导入敏感词
export const importWords = v => postfile(`${baseUrl}/importCwKmcHostforbidwordsExcel`, v.data, v.success, v.error)

// 查询经验设置数据
export const getExpData = v => post(`${baseUrl}/getStarreBatConfig`, v.data, v.success, v.error)

// 保存经验设置
export const saveExpData = v => post(`${baseUrl}/saveOrUpdateStarreBatConfig`, v.data, v.success, v.error)

// 查询等级信息
export const getStarLevelconfig = v => post(`${baseUrl}/getStarLevelconfig`, v.data, v.success, v.error)

// 初始化默认等级
export const getDefaultLevel = v => post(`${baseUrl}/getDefaultLevel`, v.data, v.success, v.error)

// 保存或编辑等级设置
export const saveOrUpdateStarlevelconfig = v => post(`${baseUrl}/saveOrUpdateStarlevelconfig`, v.data, v.success, v.error)

// 开启关闭 等级/头衔
export const saveOrUpdateHoststarconfig = v => post(`${baseUrl}/saveOrUpdateHoststarconfig`, v.data, v.success, v.error)